import { r as registerInstance, h, g as getElement } from './index-41410303.js';
import { I as InternalEventType } from './internal-event-types-8598fbfb.js';

class InternalRunDropdownValueSelectedEvent {
  constructor(payload) {
    this.TYPE = InternalEventType.INTERNAL_YASQE_DROPDOWN_ACTION_SELECTED_EVENT;
    this.payload = payload;
  }
}

const querySplitButtonCss = "query-split-button .yasqe_querySplitWrapper{position:relative;height:100%}query-split-button .yasqe_querySplitWrapper .yasqe_querySplitToggle{background-color:#9E2B0A;color:#FFFFFF;font-weight:400;height:100%;margin-left:1px;border:none;z-index:9998}query-split-button .yasqe_querySplitWrapper .yasqe_querySplitToggle:hover{background-color:#9E2B0A}query-split-button .yasqe_querySplitWrapper .yasqe-inline-dropdown{position:absolute;top:100%;margin-top:4px;min-width:140px;width:max-content;z-index:10000;display:block}query-split-button .ontotext-run-dropdown{width:max-content;position:absolute;top:100%;right:0;z-index:1400}query-split-button .ontotext-run-dropdown-menu{background-color:#FFFFFF;box-shadow:0 2px 6px rgba(0, 0, 0, 0.15);border-radius:4px;min-width:140px;font-size:13px}query-split-button .ontotext-run-dropdown-menu.open{display:block;padding:5px 0}query-split-button .ontotext-run-dropdown-menu-item{display:flex;justify-content:space-between;font-family:var(--main-font);gap:5px;padding:6px 12px;text-decoration:none;text-align:left;color:#000000;cursor:pointer}query-split-button .ontotext-run-dropdown-menu-item:hover{background-color:#F2F2F2;color:#000000;text-decoration:none}query-split-button .ontotext-run-dropdown-menu-item__label{font-size:16px;font-family:\"Roboto\", sans-serif;font-weight:400}query-split-button .ontotext-run-dropdown-menu-item__shortcut kbd{background-color:#000000;color:#FFFFFF;font-size:0.8rem}";

const QuerySplitButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.runActions = [
      { labelKey: 'yasqe.dropdown.run_query.option.explain_query_plan', value: 'explain_plan' },
      { labelKey: 'yasqe.dropdown.run_query.option.llm_explain_all', value: 'explain_all' },
      { labelKey: 'yasqe.dropdown.run_query.option.llm_explain_query', value: 'explain_query' },
      { labelKey: 'yasqe.dropdown.run_query.option.llm_explain_results', value: 'explain_results' },
    ];
    this.toggleQuerySplitMenu = () => {
      this.querySplitOpen ? this.closeQuerySplitMenu() : this.openQuerySplitMenu();
    };
    this.yasqe = undefined;
    this.translationService = undefined;
    this.eventService = undefined;
    this.querySplitOpen = false;
  }
  onWindowClick(e) {
    if (this.querySplitOpen && this.hostElement && !this.hostElement.contains(e.target)) {
      this.closeQuerySplitMenu();
    }
  }
  onWindowScroll() {
    if (this.querySplitOpen) {
      this.closeQuerySplitMenu();
    }
  }
  onKeyDown(e) {
    if (e.key === 'Escape' && this.querySplitOpen) {
      this.closeQuerySplitMenu();
    }
  }
  onWindowResize() {
    if (this.querySplitOpen) {
      this.closeQuerySplitMenu();
    }
  }
  positionDropdownMenu() {
    const splitButtonTopMargin = window.getComputedStyle(document.querySelector('.yasqe_queryButton')).marginTop;
    const splitButtonTopMarginValue = parseFloat(splitButtonTopMargin) || 0;
    const fullscreenButtonDropdownGap = 2; // Gap between the top of the button and dropdown in fullscreen mode
    const distanceFromEditorRightEdge = 33; // Distance from the right edge of the editor to the dropdown right edge
    // Using setTimeout to ensure the dropdown is re-rendered after calculating its position
    setTimeout(() => {
      const button = this.hostElement.querySelector('.yasqe_querySplitWrapper');
      const dropdown = this.hostElement.querySelector('.ontotext-run-dropdown-menu.open');
      if (button && dropdown) {
        const host = this.hostElement.closest('.yasgui-host-element');
        const isModeYasgui = !!host &&
          host.classList.contains('orientation-horizontal') &&
          host.classList.contains('mode-yasgui');
        const buttonRect = this.hostElement.getBoundingClientRect();
        const isFullscreen = this.yasqe.classList.contains('yasqe-fullscreen');
        const buttonGroup = window.getComputedStyle(document.querySelector('.yasqe_buttons'));
        // Convert the string value (like "10 px") to a number and default to 0 if not a number
        const buttonGroupRight = buttonGroup.right !== 'auto' ? parseFloat(buttonGroup.right) || 0 : 0;
        dropdown.style.position = 'fixed';
        if (!isModeYasgui) {
          const baseRight = (parseFloat(dropdown.style.right) || 0) + buttonGroupRight + distanceFromEditorRightEdge;
          dropdown.style.right = `${baseRight}px`;
        }
        else {
          dropdown.style.removeProperty('right');
        }
        const dropdownRect = dropdown.getBoundingClientRect();
        const dropdownHeight = dropdownRect.height;
        if (isFullscreen) {
          dropdown.style.top = `${buttonRect.top - dropdownHeight + splitButtonTopMarginValue}px`;
          dropdown.style.right = `${window.innerWidth - buttonRect.right}px`;
        }
        else {
          dropdown.style.top = `${buttonRect.bottom + fullscreenButtonDropdownGap}px`;
        }
      }
    });
  }
  openQuerySplitMenu() {
    this.querySplitOpen = true;
    this.positionDropdownMenu();
  }
  closeQuerySplitMenu() {
    this.querySplitOpen = false;
  }
  handleDropdownAction(action) {
    this.eventService.emit(new InternalRunDropdownValueSelectedEvent(action));
  }
  // DEV NOTE: Leaving the shortcut implementation here for use when the new icon library is chosen.
  parseShortcutLabel(shortcutLabel) {
    return shortcutLabel
      .split('-')
      .map((part) => part.trim())
      .filter((part) => part.length > 0);
  }
  render() {
    const caretClass = this.querySplitOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line';
    return (h("div", { class: "yasqe_querySplitWrapper" }, h("button", { type: "button", class: `yasqe_querySplitToggle ${caretClass}`, "aria-label": this.translationService.translate('yasqe.action.run_query.split.toggle.aria'), onClick: this.toggleQuerySplitMenu }), this.querySplitOpen && (h("div", { class: "yasqe-inline-dropdown ontotext-run-dropdown open" }, h("div", { class: "ontotext-run-dropdown-menu open", role: "menu" }, this.runActions.map((item) => (h("div", { class: "ontotext-run-dropdown-menu-item", role: "menuitem", onClick: (ev) => {
        ev.preventDefault();
        this.handleDropdownAction(item.value);
        this.closeQuerySplitMenu();
      } }, h("span", { class: "ontotext-run-dropdown-menu-item__label" }, this.translationService.translate(item.labelKey)), item.shortcut && (h("span", { class: "ontotext-run-dropdown-menu-item__shortcut" }, this.parseShortcutLabel(this.translationService.translate(item.shortcut)).map((keyPart) => (h("kbd", { class: "key" }, keyPart)))))))))))));
  }
  get hostElement() { return getElement(this); }
};
QuerySplitButton.style = querySplitButtonCss;

export { QuerySplitButton as query_split_button };
